module.exports = __webpack_public_path__ + "img/ic_cuoti_16.d12a704c.svg";